let forms   = require( './forms' ),
	popups  = require( './modals' ),
	loading = require( './loading' );

let add_staff_member_form = function( $ ) {

	let $current_form, // Current form being submitted
		$forms,
		$popup_email,
		$popup_no_email,
		should_show_popup_on_autosave = false; // This is a bit messy but its the only way I could think of to not show the popup on every autosave success

	let _init = function() {
		$forms          = $( 'form#add-staff-form, form#add-staff-no-email-form' );
		$popup_email    = $( '#practice-account-add-staff-popup' );
		$popup_no_email = $( '#practice-account-add-staff-no-email-popup' );

		if ( $forms.length > 0 && ( $popup_email.length > 0 || $popup_no_email.length > 0 ) ) {
			_setup_form_submission();
			_setup_form_submit_click();

			$forms.each( ( index, item ) => {
				let $form = $( item );

				if ( $form.length > 0 ) {
					$form.on( 'autosave_success', ( response ) => {

						if ( should_show_popup_on_autosave ) {
							if ( $form.find( '#field_email' ).val() ) {
								_update_popup(  'email', $form.find( '#field_email' ).val() );
							} else {
								// No email so show name
								_update_popup( 'no-email', $form.find( '#field_first_name' ).val() + ' ' + $form.find( '#field_last_name' ).val() );
							}

							if ( $form.attr( 'id' ) === 'add-staff-no-email-form' ) {
								_show_popup( 'no-email' )
							} else {
								_show_popup();
							}

							$current_form = $form;
						}

						should_show_popup_on_autosave = false;
					} );
				}
			} );
		}
	};

	let _setup_form_submission = function() {
		$forms.each( ( index, item ) => {
			$( item ).closest( '.form-wrapper' ).find( '.submit-form' ).on( 'click', function ( e ) {
				let $form = $( this ).closest( '.form-wrapper' ).find( 'form' );

				e.preventDefault();

				_validate_form( $form );
			} );
		} )
	};

	let _validate_form = function( $validate_form ) {
		let $wrapper = $validate_form.closest( '.form-wrapper' );

		$wrapper.loading();

		forms.set_submission_attempted_external( $validate_form );
		forms.save_external( $validate_form.attr( 'id' ), true );

		should_show_popup_on_autosave = true;

		$wrapper.loaded();
	};

	let _show_popup = function( type = 'email' ) {
		popups.close_all_modals();

		if ( type === 'no-email' ) {
			popups.open_modal( $popup_no_email );
		} else {
			popups.open_modal( $popup_email );
		}
	};

	let _update_popup = function( type = 'email', email_address ) {
		if ( type === 'no-email' ) {
			$popup_no_email.find( '.email-address' ).text( email_address );
		} else {
			$popup_email.find( '.email-address' ).text( email_address );
		}
	};

	let _submit_form = function( $submit_form ) {
		$submit_form.trigger( 'submit-form' );
		popups.close_all_modals();
	};

	let _setup_form_submit_click = function() {
		$popup_email.find( '#add-staff-member-button' ).on( 'click', ( e ) => {
			e.preventDefault();
			_submit_form( $current_form );
		} );

		$popup_no_email.find( '#add-staff-member-button' ).on( 'click', ( e ) => {
			e.preventDefault();
			_submit_form( $current_form );
		} );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = add_staff_member_form;